import React from "react";

/** Props for a custom Y-axis label that renders two lines (avoids clipping long text). */
export type YAxisLabelTwoLinesProps = {
  lines: [string, string];
  fill?: string;
  fontSize?: number;
  /** Vertical offset from default position (positive = lower). */
  dy?: number;
  /** Props passed by Recharts to the label content renderer. */
  viewBox?: { x?: number; y?: number; width?: number; height?: number };
  [key: string]: unknown;
};

/**
 * Renders a two-line label for the Y-axis so long text (e.g. "Normalized Magnetomotive Force")
 * is fully visible and not clipped. Use as YAxis label content.
 */
const YAxisLabelTwoLines: React.FC<YAxisLabelTwoLinesProps> = ({
  lines,
  fill = "#000",
  fontSize = 11,
  dy = 56,
  viewBox = {},
}) => {
  const x = typeof viewBox?.x === "number" ? viewBox.x : 20;
  const y = typeof viewBox?.y === "number" ? viewBox.y : 0;
  const height = typeof viewBox?.height === "number" ? viewBox.height : 280;
  const midY = y + height / 2;

  return (
    <g transform={`translate(${x}, ${midY})`}>
      <text
        textAnchor="middle"
        fill={fill}
        fontSize={fontSize}
        transform="rotate(-90, 0, 0)"
        style={{ fontFamily: "inherit" }}
      >
        <tspan x={0} dy={0}>
          {lines[0]}
        </tspan>
        <tspan x={0} dy={fontSize + 2}>
          {lines[1]}
        </tspan>
      </text>
    </g>
  );
};

export default YAxisLabelTwoLines;
